import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { initLenis, destroyLenis } from "@/lib/lenis";
import { AuthProvider } from "@/context/AuthContext";
import ErrorBoundary from "@/components/ErrorBoundary";
import AuthCallback from "@/components/AuthCallback";
import AuthModal from "@/components/AuthModal";
import Admin from "@/pages/Admin";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Story from "@/components/Story";
import Shloka from "@/components/Shloka";
import Impact from "@/components/Impact";
import Farm from "@/components/Farm";
import Products from "@/components/Products";
import Directors from "@/components/Directors";
import Visit from "@/components/Visit";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    initLenis();
    return () => destroyLenis();
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <AppShell />
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

function AppShell() {
  const location = useLocation();

  // OAuth return: detect session_id synchronously during render — it must be
  // exchanged before any /auth/me check runs.
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <Toaster position="bottom-right" richColors />
      <AuthModal />
    </>
  );
}

function Landing() {
  return (
    <div className="bg-cream text-coal font-sans antialiased">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Story />
        <Shloka />
        <Impact />
        <Farm />
        <Products />
        <Directors />
        <Visit />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
